import axios from "axios";
import generalStore from "../../components/Stores/SurveyStore"
import store from "../../components/Stores/IbsSurveyStore";
import sharedStore from "../../components/Stores/SharedStore";
import {getAllTableDataDB, getDbAssetStyles, getAssetStyleForAllCategories, getIBSPlanResults, updateSurveyInfoCtrl} from "../../control";
import { setActualErrorCommentValue} from "../../helpers";
import {AssetCategoryNames, CURRENT_DATA_YEAR} from "../../Enums/constants";
import {handleNoSurvey, getTemplateData, GetSurveySubmissionsByDate} from "./IbsService";
import numeral from "numeral";
import {toast} from "react-toastify";
import {DbSortFunctionForMandateAssets, isLGPS, hasMandatesCheck, updateLinkedPrivateEquityRow, convertMandateSubstyleToID, convertGrossNetReturnOptionToID, convertMandateRegionToID, refreshDealTermsTab} from "../../ibsHelper";
import { getCookie } from "../Authentication/AuthHelper";
import IbsSubmitPage from "../../components/IbsSubmitPage";
import { toJS } from "mobx";

export async function hasBundledLDIAssets() {
    var surveyId;
    if (store.currentSurvey)
        surveyId = store.currentSurvey.SurveyID;
    if (surveyId) {
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + getCookie("access_token")
            },
            params: {
                surveyId: surveyId
            }
        };
        await axios
            .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/HasBundledLDIAssets", config)
            .then(response => {
                sharedStore.bundledLDI = response.data;
            })
            .catch(error => {
                console.log(error);
            });
    }
}

export async function getDataYear() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {

        }
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/GetDataYear", config)
        .then(response => {
            sharedStore.currentDataYear = response.data;
        })
        .catch(error => {
            console.log(error);
        });
}

export async function getMandateSubstyles() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/GetMandateSubstyles", config)
        .then(response => {
            sharedStore.mandateSubstyles = response.data.value
        })
        .catch(error => {
            console.log(error);
        });
}

export async function getMandateRegions() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/GetMandateRegions", config)
        .then(response => {
            sharedStore.mandateRegions = response.data.value
        })
        .catch(error => {
            console.log(error);
        });
}
export async function SetCultureFromSurvey(surveyId) {
    const config = {
        headers : {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId
        }
    }
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/CultureIdentifier", config)
        .then(response => {
            sharedStore.cultureIdentifier = JSON.parse(response.data)
            numeral.locale(sharedStore.cultureIdentifier)
        })
        .catch(error => {
            console.log(error);
        });
}

/**
 * Requests the opened survey's details
 * */
export async function setCurrentDBSurvey(defaultDataYear, surveyId) {
    var survey
    var result

    if (surveyId) {
        result = generalStore.allAvailableSurveys.filter(survey => survey.SurveyID == surveyId && survey.ProductID==1);
    } else if (generalStore.allAvailableSurveys.length > 0) {
        result = generalStore.allAvailableSurveys.filter(survey => survey.ProductID == 1);
        result = result.reduce(function (prev, curr) {
            return (prev.DataYear > curr.DataYear) ? prev : curr
        })
    } 

    //fallback for analysts
    if (result.length ==0 && store.accountInfo.UserRoleID == 3) {
        if (surveyId) {
            result = generalStore.availableSurveys.filter(survey => survey.SurveyID == surveyId && survey.ProductID == 1);
        } else if (generalStore.availableSurveys.length > 0) {
            result = generalStore.availableSurveys.filter(survey => survey.ProductID == 1);
            result = result.reduce(function (prev, curr) {
                return (prev.DataYear > curr.DataYear) ? prev : curr
            })
        } 
    }
    if (Array.isArray(result)) {
        survey = result[0]
    } else {
        survey = result
    }
    if (!survey) handleNoSurvey("DB", defaultDataYear)
    //in some situation here, we must create a new survey!! if it does not exist it seems
    try {
        let previouslyLoadedSurvey;
        if (store.currentSurvey)
            previouslyLoadedSurvey = store.currentSurvey
        
        store.currentSurvey = survey;
      
        if (!store.currentSurvey) {
            if (!window.location.href.includes("/db/home")) window.location.replace("/db/home")
        }
        else {
            if (window.location.href.includes("/ibs/laundromat")){
                // don't go to home if user is going to laundromat
            } else {
                if (!window.location.href.includes("/db")) {
                    if (window.location.href.includes("/ibs/home")) {
                        window.location.replace("/db/home")
                    }
                    else if (!window.location.href.includes("/db/home")) {
                        let page = store.currentSurvey.isAgreed || store.currentSurvey.DataYear < CURRENT_DATA_YEAR ? "Planinfo" : "TermsAndConditions"
                        window.location.replace("/db/" + page)
                    } else {
                        window.location.replace("/db/home")
                    }
                }
                localStorage.setItem("lastOpenedSurveyIdCacheDB", JSON.stringify(store.currentSurvey.SurveyID))    
            }
        }
        if (survey.DataYear) {
            let parsedDataYear = parseInt(survey.DataYear);
            if (!Number.isNaN(parsedDataYear)) generalStore.currentYear = parsedDataYear;
        }
        store.sessionChanges = store.currentSurvey?.NumChanges;

    } catch (e) {
        console.log('Missing survey: ', e);
    }

    if (store.currentSurvey) {
        //do this every time for latest data
        await SetCultureFromSurvey(store.currentSurvey.SurveyID);
        await hasBundledLDIAssets();
        await Promise.all([
            getDbAssetStyles(),
            getResponseDataDB(),
            getAllTableDataDB(),
            GetMandateData(),
            GetInternalTeams(),
            GetLastYearAssetTeamMappings(),
            getAllSurveyErrorsDB(),
            getTemplateData(),
            getIBSPlanResults(),
            getAssetStyleForAllCategories()]).catch((error) => {
                console.error(error.message);
            });

        //Get Last Year Data
        let lySurveyInfo = generalStore.availableSurveys.filter(survey => survey.DataYear == store.currentSurvey.DataYear - 1)
        if (lySurveyInfo.length>0) await GetMandateData(lySurveyInfo[0].SurveyID) //LY mandatedata
        if (lySurveyInfo.length >0) await getAllTableDataDB(lySurveyInfo[0].SurveyID) //LY mandatedata
        generalStore.loadingSurvey = false;
    }
}


export async function getResponseDataDB() {
    var surveyId;
    if (store.currentSurvey) surveyId = store.currentSurvey.SurveyID;
    else {
        surveyId = localStorage.getItem("lastOpenedSurveyIdCacheDB");
    }
    if (surveyId) {
        const config = {
            headers: {
               Accept: 'application/json',
               Authorization: 'Bearer ' + getCookie("access_token")
            },
            params: {
                surveyId: surveyId
            }
    
        };
        axios
            .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/GetSurveyResponses", config)
            .then(response => {
                if (response.data == "null") store.allResponses = {}
                else store.allResponses = JSON.parse(response.data)
            })
            .catch(error => {
                store.databaseConnection = false;
                console.log(error);
            });
    }

}

export async function getAssetCategories(forceFetch = false) {
    if(store.assetClassCategories.length > 0) {
        // variable in store is already filled with data
        if(!forceFetch) {
            // fetch is not forced, so just return without doing anything
            return; 
        }
    }
    
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            
        }
    };
    
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/GetAssetCategories", config)
        .then(response => {
            store.assetClassCategories = response.data;
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });
}

export async function GetLastYearAssetTeamMappings() {
    const planId = store.currentSurvey.PlanID;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            planId: planId
        }
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/GetLastYearAssetTeamMappings", config)
        .then(async response => {
            var response = JSON.parse(response.data);
            var test = {};
            response.forEach(e => {
                test[e.StyleID.toString()] = e
            });
            store.defaultAssetStyleIDMap[planId.toString()] = test;
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });
}

export async function getTableDataDb(tableName, isRequestingData, surveyIdOverride) {
    //isRequestingData -> not sure why it is passed in, naming is guess
    let surveyId = store.currentSurvey.SurveyID;
    if (!isNaN(surveyIdOverride) && surveyIdOverride!=store.currentSurvey.SurveyID) surveyId = surveyIdOverride
    const planId = store.currentSurvey.PlanID;
    const countryId = store.currentSurvey.CountryID;
    const isMandateLevel = store.checkMandateLevel;
    
    const config = {
        headers: {
           Accept: 'application/json',
           Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            tableName: tableName,
            surveyId: surveyId, 
            planId: planId,
            countryId: countryId,
            isMandateLevel: isMandateLevel ?? null
        },
    };

    // Make sure AssetCategories are loaded for the display order lookup
    // this will not fetch if already fetched.
    await getAssetCategories(false);

    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/GetDataTable", config)
        .then(async response => {
            const parsedData = JSON.parse(response.data);

            if (tableName === "PrivateEquity") {
                if (parsedData.length > 0)
                    store.allTableResponses[tableName] = parsedData
                else
                    store.allTableResponses[tableName] = null

            } else {
                if (surveyIdOverride && surveyIdOverride != store.currentSurvey.SurveyID) {
                    //for pulling last years Asset data!
                    store.lyAssetData[tableName] = (response.data !== undefined && response.data !== null)
                        ? parsedData
                        : []
                    return
                } else {
                    store.allTableResponses[tableName] =
                        (response.data !== undefined && response.data !== null)
                            ? parsedData
                            : []
                }
             
            }
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });

}

export const saveInputValueDB= async(inputName, value, tableName, rowId)=> {
    const surveyId = store.currentSurvey.SurveyID;
    const page = generalStore.currentLandedPage;
    const isAnalyst = store.accountInfo?.UserRoleID == 3;

    if (rowId == 0) {
        rowId = null;
    }
    if (typeof value === "undefined") {
        value = null;
    }

    let toastId = null;
    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: sharedStore.identityConfig.clientRoot + "api/DbSurvey/SaveResponse",
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token"),
        },
        params: {
            QuestionName: inputName,
            tableName: tableName,
            page: page,
            surveyId: surveyId,
            rowId: rowId,
            isAnalyst: isAnalyst
        },
        data: JSON.stringify(value)
    };
    return await axios.request(config)
        .then(response => {
            var ErrorMap = JSON.parse(response.data);
            var errorPage = generalStore.currentURL.split("/").slice(-1)[0].trim().replace(/([a-z])([A-Z])/g, '$1_$2');
            var curErrorPage = errorPage.replace("_", "").toLowerCase();
            for (let key in ErrorMap) {
                ErrorMap[key.replace("_", "").toLowerCase()] = ErrorMap[key];
                delete ErrorMap[key];
            }
            var errors = ErrorMap[curErrorPage];
            var storeErrors;
            if (curErrorPage in generalStore.allValidationErrorsList) storeErrors = generalStore.allValidationErrorsList[curErrorPage];

            if (tableName == 'Benchmark') {
                getAllTableDataDB(tableName);
            }
            store.checkedSurvey = false;

            if (typeof (errors) !== "undefined") {
                errors.forEach(error => {
                    // Lets do the same thing as the PABS stuff
                    if (storeErrors && storeErrors.length > 0) {
                        var index = storeErrors.findIndex(obj => {
                            if (error.QuestionName === "CheckTotalPolicy") { error.RowID = 1 }
                            if (error.QuestionName === "CheckTotalAssetMix") { error.RowID = 1 }
                            if (tableName)
                                return obj.QuestionName.toLowerCase() == error.QuestionName.toLowerCase() && obj.RowID === error.RowID;
                            else
                                return obj.QuestionName.toLowerCase() == error.QuestionName.toLowerCase();
                        })
                    }
                    var replace = true;
                    if (index >= 0) {
                        if (error.IsRemove || error.RuleStatus == "Pass" || error.ErrorId != storeErrors[index].ErrorId) {
                            storeErrors.splice(index, 1)
                        }
                        else
                            replace = false;
                    }
                    if (replace && !error.IsRemove && error.RuleStatus != "Pass") {
                        storeErrors.push(error)
                    }
                })
                generalStore.allValidationErrorsList[curErrorPage] = storeErrors;
            }
            return (ErrorMap)
            })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
            if (toastId) {
                toast.update(toastId, {
                    render: "Error saving.  Please refresh the page and try again.",
                    type: toast.TYPE.INFO,
                    className: "red-notif",
                    autoClose: 10000
                });
            } else {
                toast("Error saving.  Please refresh the page and try again.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    draggable: false,
                    autoClose: 4000,
                    hideProgressBar: true,
                    className: "red-notif"
                });
            }
        });
}

export function getAllSelectCombos() {
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DcSurvey/GetAllSelectCombos")
        .then(response => {
            var testDict = {}
            response.data.forEach(function (item, index) {
                testDict[item.PlanTypeName] = item.PlanTypeID
            });
            const keys = Object.keys(testDict) //dropdown options
            store.selectCombosTest = testDict
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });

}

export async function insertMandatePrivateEquityRow(mandateId, partnershipName, vintageYear) {
    const surveyId = store.currentSurvey.SurveyID;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId : surveyId,
            partnershipName: partnershipName,
            year: vintageYear,
            navValue: null, 
            mandateId: mandateId

        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/InsertMandatePrivateEquity", config)
        .then(response => {
            const responseData = JSON.parse(response.data)

            if (store.allTableResponses["PrivateEquity"] === undefined || store.allTableResponses["PrivateEquity"] === null) {
                store.allTableResponses["PrivateEquity"] = [responseData];
            } else {
                store.allTableResponses["PrivateEquity"].push(responseData);
            }
        }
    )

}

export async function addRowToTable(assetClassId, styleId, tableName, catID) {
    // var surveyId = store.accountInfo.DefinedBenefit.SurveyID;
    const surveyId = store.currentSurvey.SurveyID;
    let returnType = 0;
    //assign return type id
    if (tableName == "CombinedDBTable") {
        returnType = 2
    }
   
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            table: tableName,
            assetClassId: assetClassId,
            styleId: styleId, 
            surveyId: surveyId, 
            returnID: returnType
        },
    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/InsertRow", config)
        .then(response => {
            const responseData = JSON.parse(response.data)
            store.lastRowAdded = responseData.RowID

            if (tableName == "CombinedDBTable") {
                if (store.allTableResponses["combinedAssets"] === undefined || store.allTableResponses["combinedAssets"] === null) {
                    store.allTableResponses["combinedAssets"] = [responseData];
                } else {
                    store.allTableResponses["combinedAssets"].push(responseData);
                }
                // Scroll to the row in the viewpane
               
            } else {
                if (responseData !== null) {
                    if(store.allTableResponses[tableName] === undefined || store.allTableResponses[tableName] === null) {
                        store.allTableResponses[tableName] = [responseData];
                    } else {
                        store.allTableResponses[tableName].push(responseData);
                    }
                }
            }
            if (store.lastRowAdded) {
                let element = document.getElementById(store.lastRowAdded);
                if (element === null) {
                    element = document.getElementById(`A${store.lastRowAdded}`);
                    if (element === null) {
                        return;
                    }
                }

                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
            
        });

}

export async function deleteRowFromTable(rowId, tableName) {
    const surveyId = store.currentSurvey.SurveyID;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            table: tableName,
            surveyId: surveyId,
            rowId: rowId
        },
    };
    
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/DeleteRow", config)
        .then(response => {
            let result;
            if (tableName == "CustomGroupings") {
                result = store.allTableResponses[tableName].findIndex(row => row["CustomAssetID"] == rowId);
            } else if (tableName == "mandate") {
                tableName = "combinedAssets"
                result = store.allTableResponses[tableName].findIndex(row => row["RowID"] == rowId);

            } else {
                result = store.allTableResponses[tableName].findIndex(row => row["RowID"] == rowId);

            }
            
            const assetClassId = store.allTableResponses[tableName][result]?.AssetClassID;
            store.allTableResponses[tableName].splice(result, 1);
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });
}

export async function getAssetStylesByCategory(categoryId) {
    var surveyId = store.currentSurvey.SurveyID
    if (store.currentSurvey) surveyId = store.currentSurvey.SurveyID;

    if (surveyId) {
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + getCookie("access_token")
            },
            params: {
                surveyId: surveyId,
                category: categoryId
            },
        };
        await axios
            .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/GetAssetStylesByCategory", config)
            .then(response => {
                let catName = "cat" + categoryId.toString()
                store.assetStylesForCat[catName] = JSON.parse(response.data)
               
            })
            .catch(error => {
                store.databaseConnection = false;
                console.log(error);
            });
    }
}

export async function getAllSurveyErrorsDB() {
    await getPageErrorsDB("Plan_Info");
    await getPageErrorsDB("Assets");
    await getPageErrorsDB("Benchmarks");
    await getPageErrorsDB("Transaction_Costs");
    await getPageErrorsDB("Liability");
    await getPageErrorsDB("Ltd_Partnerships");
    await getPageErrorsDB("Expenses");
}

export async function getPageErrorsDB(page) {
    var surveyId = store.currentSurvey.SurveyID;

    var errorListForPage;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            page: page,
            surveyId: surveyId,
        },

    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/GetPreLoadPageError", config)
        .then(response => {
            errorListForPage = JSON.parse(response.data);
            generalStore.allValidationErrorsList["combinedAssets"] = []
            //temp
            let pageName = page.replace("_","").toLowerCase()
            if (errorListForPage.length >= 0) {
                generalStore.allValidationErrorsList[pageName] = errorListForPage;
                generalStore.allValidationErrorsList["combinedAssets"] = generalStore.allValidationErrorsList["combinedAssets"].concat(errorListForPage);
            }
            
        })
        .catch(error => {
            console.log(error, page);
        });

}

export async function validateDBSurvey() {
    const surveyId = store.currentSurvey.SurveyID;
    const isAnalystUser = store.accountInfo.UserRoleID == 3;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
            isAnalyst: isAnalystUser
        },
    };
    
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/ValidateDbSurvey", config)
        .then(response => {
            generalStore.loadingErrorSummaryDone = true;
            store.checkedSurvey = true;
            
            const errorSummary = JSON.parse(response.data);
            generalStore.surveyAllErrors = errorSummary.list;
            
            getAllSurveyErrorsDB();
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });

}

export function submitDBSurvey() {
    var surveyId = store.currentSurvey.SurveyID;
    const isAnalystUser = store.accountInfo.UserRoleID == 3;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
            isAnalyst: isAnalystUser
        },
    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/submitDBSurvey", config)
        .then(async response => {
            store.currentSurvey.SurveyStatusID = 2;
            getIBSPlanResults()
            if(isAnalystUser)
                await GetSurveySubmissionsByDate();
        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });

}

export function unlockDBSurvey() {
    var surveyId = store.currentSurvey.SurveyID;
    const isAnalystUser = store.accountInfo.UserRoleID == 3;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
            isAnalyst: isAnalystUser
        },
    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/UnlockDBSurvey", config)
        .then(response => {
            store.currentSurvey.SurveyStatusID = null;

        })
        .catch(error => {
            store.databaseConnection = false;
            console.log(error);
        });
}

export function AddErrorCommentsByIdDB(errorId, errorExplanation) {
    var surveyId = store.currentSurvey.SurveyID

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
            errorExplanation: errorExplanation,
            errorId: errorId
        },

    };
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/UpdateErrorExplanationById", config)
        .then(response => {
            setActualErrorCommentValue()
        })
        .catch(error => {
        });
}

export async function GetMandateData(surveyID) {
    //const surveyID = store.currentSurvey.SurveyID;
    if (!surveyID) surveyID = store.currentSurvey.SurveyID;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyID,
        },
    };
    
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/GetMandateData", config)
        .then(response => {
            if (surveyID != store.currentSurvey.SurveyID) {
                store.lyMandataData = response.data.value
                return
            }
            store.mandateData = (response.data !== undefined && response.data !== null) 
                ? response.data.value.sort(DbSortFunctionForMandateAssets)
                : [];
            store.mandateInfo = store.mandateData.value
            
            hasMandatesCheck()

        })
        .catch(error => {
            console.log(error);
        });

}
export async function GetInternalTeams() {
    const surveyId = store.currentSurvey.SurveyID;
    
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,

        },

    };
    
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/GetInternalTeams", config)
        .then(response => {
           
            const parsedData = JSON.parse(response.data);
            store.allTableResponses["FrontOffice"] =
                (response.data !== undefined && response.data !== null)
                    ? parsedData
                    : []

        })
        .catch(error => {
            console.log(error);
        });
}

export async function GetAssetStylesDB() {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
        },

    };
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/GetAllDbStyles", config)
        .then(response => {
            store.dbStylesMap = response.data

        })
        .catch(error => {
        });

}
export async function GetDefaultCosts() {
    let dataYear = store.currentSurvey.DataYear;
    let surveyID = store.currentSurvey.SurveyID;
    
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyID: surveyID,
            dataYear: dataYear,
        },

    };
    
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/GetDbDefaultCostsNew", config)
        .then(response => {
            store.dbDefaultCosts = response.data

        })
        .catch(error => {
            //console.log(error, page);
        });

}
export function UpdateMandateInfoSingle(qId, value, mandateId) {
    let surveyId = store.currentSurvey.SurveyID;
    
    if (value=="null") value = null
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
            id: qId,
            value: value,
            mandateId: mandateId
        },

    };

    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/UpdateMandateInfoSingle", config)
        .then(response => {
            //update mandateYearAdded or mandateYearEnded depending on lifecycleStatus value
            if (qId == "LifeCycleStatus") {
                let lifeCycleStatus = value
                if (lifeCycleStatus == 1) {
                    //new mandate
                    UpdateMandateInfoSingle("MandateYearStart", store.currentSurvey.DataYear, mandateId)
                    UpdateMandateInfoSingle("MandateYearEnd", null, mandateId)
                } else if (lifeCycleStatus == 2) {
                    //terminated status
                    UpdateMandateInfoSingle("MandateYearEnd", store.currentSurvey.DataYear, mandateId)
                    UpdateMandateInfoSingle("MandateYearStart", null, mandateId)
                } else {
                    UpdateMandateInfoSingle("MandateYearStart", null, mandateId)
                    UpdateMandateInfoSingle("MandateYearEnd", null, mandateId)

                }
            }
           
        })
        .catch(error => {
            console.log(error);
            toast("Error: Could not edit Mandate.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                draggable: false,
                autoClose: 4000,
                hideProgressBar: true,
                className: "red-notif"

            });
        });
}

export function UpdateMandateInfo() {
    let surveyId = store.currentSurvey.SurveyID;
    let managerName = store.mandateModalInfo.ManagerName
    let fundName = store.mandateModalInfo.FundName
    let mandateID = store.mandateModalInfo.MandateID
    let isLGPS = store.mandateModalInfo.IsLgpsPoolOptions
    let isSingle = store.mandateModalInfo.IsSingleMandate
    let isInCommitPeriod = store.mandateModalInfo.IsInCommitPeriod
    let assetID = store.mandateModalInfo.AssetClassID
    let styleID = store.mandateModalInfo.StyleID
    let planID = store.currentSurvey.PlanID
    let catID = store.mandateModalInfo.AssetCatID
    let assetName = store.mandateModalInfo.AssetClassName
    let styleName = store.mandateModalInfo.StyleName
    let vintageYear = store.mandateModalInfo.VintageYear
    let commitmentEndYear = store.mandateModalInfo.CommitmentEndYear
    let lifeCycleStatus = store.mandateModalInfo.LifeCycleStatus
    let relRowNum = store.mandateModalInfo.RelativeRowNum
    let accountCode = store.mandateModalInfo.AccountCode
    let mandateRegionID = store.mandateModalInfo.MandateRegionID ? convertMandateRegionToID("mandateRegionID", store.mandateModalInfo.MandateRegionID):null
    let subStyleId1 = store.mandateModalInfo.MandateSubstyles[0] ? convertMandateSubstyleToID("subStyleID1", store.mandateModalInfo.MandateSubstyles[0]):null
    let subStyleId2 = store.mandateModalInfo.MandateSubstyles[1] ? convertMandateSubstyleToID("subStyleID2", store.mandateModalInfo.MandateSubstyles[1]):null
    let subStyleId3 = store.mandateModalInfo.MandateSubstyles[2] ? convertMandateSubstyleToID("subStyleID3", store.mandateModalInfo.MandateSubstyles[2]):null
   
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
            managerName: managerName,
            fundName: fundName,
            mandateId: mandateID,
            planId: planID,
            isLgpsPool: isLGPS,
            isSingle: isSingle,
            assetClassId: assetID,
            styleId: styleID,
            vintageYear: vintageYear,
            commitmentEndYear: commitmentEndYear,
            lifeCycleStatus: lifeCycleStatus, 
            accountCode: accountCode, 
            isInCommitPeriod: isInCommitPeriod, 
            subStyleID1: subStyleId1,
            subStyleID2: subStyleId2,
            subStyleID3: subStyleId3, 
            mandateRegionID:mandateRegionID
        },

    };
   
    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/UpdateMandateInfo", config)
        .then(response => {
            store.lastRowAdded = null;
            let changedRow = store.mandateData.findIndex(obj => obj.mandateID == mandateID)
            let catName = AssetCategoryNames[catID]
         
            if (changedRow >= 0) Object.assign(store.mandateData[changedRow], { managerName: managerName, fundName: fundName, isLgpsPoolOption: isLGPS, isSingleMandate: isSingle, isInCommitPeriod: isInCommitPeriod, assetClassCategoryName: catName, assetClassID: assetID, styleID: styleID, assetClassName: assetName, styleName: styleName, accountCode: accountCode, vintageYear: vintageYear, commitmentEndYear: commitmentEndYear, mandateRegionID: mandateRegionID, subStyleID1: subStyleId1, subStyleID2: subStyleId2, subStyleID3: subStyleId3})
            hasBundledLDIAssets()

            //this triggers rerender... not ideal
            store.lastRowAdded = store.mandateData[changedRow].rowID

            //updateLinkedPrivateEquityRow(managerName, fundName, vintageYear, styleID, mandateID)
            
            
          
        })
        .catch(error => {
            console.log(error);
            toast("Error: Could not edit Mandate.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                draggable: false,
                autoClose: 4000,
                hideProgressBar: true,
                className: "red-notif"

            });
        });

}

//export function addMandateLP() {
    
//}

export function AddMandateRow() {
    let surveyId = store.currentSurvey.SurveyID;
    let managerName = store.mandateModalInfo.ManagerName
    let fundName = store.mandateModalInfo.FundName
    let mandateID = store.mandateModalInfo.MandateID
    let isLGPSPool = store.mandateModalInfo.IsLgpsPoolOptions
    let isSingle = store.mandateModalInfo.IsSingleMandate
    let assetID = store.mandateModalInfo.AssetClassID
    let styleID = store.mandateModalInfo.StyleID
    let planID = store.currentSurvey.PlanID
    let catID = store.mandateModalInfo.AssetCatID
    let vintageYear = store.mandateModalInfo.VintageYear
    let commitmentEndYear = store.mandateModalInfo.CommitmentEndYear
    let isInCommitPeriod = store.mandateModalInfo.IsInCommitPeriod
    let dataYearAdded = store.currentSurvey.DataYear
    let returnMonth = isLGPS() ? 3 : 12;
    let accountCode = store.mandateModalInfo.AccountCode
    let returnType = 2
    let mandateRegionID = store.mandateModalInfo.MandateRegionID ? convertMandateRegionToID("mandateRegionID", store.mandateModalInfo.MandateRegionID) : null
    let subStyleId1 = store.mandateModalInfo.MandateSubstyles[0] ? convertMandateSubstyleToID("subStyleID1", store.mandateModalInfo.MandateSubstyles[0]) : null
    let subStyleId2 = store.mandateModalInfo.MandateSubstyles[1] ? convertMandateSubstyleToID("subStyleID2", store.mandateModalInfo.MandateSubstyles[1]) : null
    let subStyleId3 = store.mandateModalInfo.MandateSubstyles[2] ? convertMandateSubstyleToID("subStyleID3", store.mandateModalInfo.MandateSubstyles[2]) : null

    //find its parent asset row and take the return id from it
    let correspondingParentAsset = store.allTableResponses["combinedAssets"]
        .find(asset => asset.AssetClassID === assetID && asset.StyleID === styleID)
    if (correspondingParentAsset && correspondingParentAsset.ReturnTypeIDAssets != 0) {
        returnType = correspondingParentAsset.ReturnTypeIDAssets;
    } else {
        returnType = 2
    }

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            surveyId: surveyId,
            managerName: managerName,
            fundName: fundName,
            mandateId: mandateID,
            planId: planID,
            isLgpsPool: isLGPSPool,
            isSingle: isSingle,
            assetClassId: assetID,
            styleId: styleID,
            vintageYear: vintageYear,
            commitmentEndYear: commitmentEndYear,
            isInCommitPeriod: isInCommitPeriod,
            returnMonth: returnMonth,
            accountCode: accountCode,
            returnTypeIdAssets: returnType,
            dataYearAdded: dataYearAdded,
            subStyleID1: subStyleId1,
            subStyleID2: subStyleId2,
            subStyleID3: subStyleId3,
            mandateRegionID: mandateRegionID
        },

    };

    axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/AddMandate", config)
        .then(response => {
            const temp = store.mandateData;
            temp.push(response.data);
            store.mandateData = temp.sort(DbSortFunctionForMandateAssets)
            hasMandatesCheck()

            store.lastRowAdded = response.data.rowID
            if (store.lastRowAdded && document.getElementById(store.lastRowAdded)) {
                const yOffset = -200;
                const element = document.getElementById(store.lastRowAdded);
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            hasBundledLDIAssets()


        })
        .catch(error => {
        });

}



export async function deleteMandate(managerName, fundName) {
    const mandateID = store.mandateModalInfo.MandateID
    const styleID = store.mandateModalInfo.StyleID
    const surveyID = store.currentSurvey.SurveyID;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        },
        params: {
            mandateID: mandateID,
            surveyID: surveyID,
        },

    };
    
    await axios
        .get(sharedStore.identityConfig.clientRoot + "api/DbSurvey/DeleteMandate", config)
        .then(response => {
            hasBundledLDIAssets()

            let deletedRow = store.mandateData.findIndex(obj => obj.mandateID == mandateID)
            store.mandateData.splice(deletedRow, 1)

            store.lastRowAdded = mandateID //this triggers a rerender....yikes
            hasMandatesCheck()

            if (styleID == 16) {
                //use MandateID to find rowID of Private Equity datarow and delete it
                let deletedRow = store.allTableResponses["PrivateEquity"].find(obj => obj.MandateID == mandateID)
                let deletedRowID = deletedRow.RowID
                deleteRowFromTable(deletedRowID, "PrivateEquity")
            }
        })
        .catch(error => {
        });

}


/**
 * Requests for cost data used in the sample results
 * */
export async function changeDBSurveyCleaner(surveyId, surveyCleaner) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }, params: {
            surveyId: surveyId,
            surveyCleaner: surveyCleaner
        }

    };
    await axios
        .get("/api/DbSurvey/SaveSurveyCleaner", config)
        .then(response => {
            var surveys = store.surveyListDisplay.filter(survey => {
                return survey.SurveyID == surveyId;
            })
            if (surveys.length > 0) {
                surveys[0].SurveyCleaners = surveyCleaner;
            }
        })
        .catch(error => {
            console.log(error);
        });
}

export async function changeDBSurveyCleanerID(surveyId, id) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }, params: {
            surveyId: surveyId,
            id: id
        }

    };
    await axios
        .get("/api/DbSurvey/SaveSurveyCleanerID", config)
        .then(response => {
            var surveys = store.surveyListDisplay.filter(survey => {
                return survey.SurveyID == surveyId;
            })
            if (surveys.length > 0) {
                surveys[0].SurveyCleanerID = id;
            }
        })
        .catch(error => {
            console.log(error);
        });
}

export async function changeDBSurveyCleanerFields(surveyId, id, surveyCleaner) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }, params: {
            surveyId: surveyId,
            id: id,
            surveyCleaner: surveyCleaner
        }

    };
    await axios
        .get("/api/DbSurvey/SaveSurveyCleanerFields", config)
        .then(response => {
            var surveys = store.surveyListDisplay.filter(survey => {
                return survey.SurveyID == surveyId;
            })
            if (surveys.length > 0) {
                surveys[0].SurveyCleanerID = id;
                surveys[0].SurveyCleaners = surveyCleaner;
            }
        })
        .catch(error => {
            console.log(error);
        });
}

export function addBenchmarkPolicy(assetid, assetClassName) {
    const surveyID = store.currentSurvey.SurveyID;

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }, params: {
            surveyID: surveyID,
            assetId: assetid,

        }

    };
    axios
        .get("/api/DbSurvey/AddBenchmarkPolicy", config)
        .then(response => {
            let policy = JSON.parse(response.data)
            store.allTableResponses["Benchmark"].push(policy);
            store.lastRowAdded = policy.RowID
        })
        .catch(error => {
            console.log(error);
        });
}

/**
 * Requests for cost data used in the sample results
 * */
export async function changeDBSurveyStatus(surveyId, statusTypeId) {
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }, params: {
            surveyId: surveyId,
            surveyStatusTypeId: statusTypeId

        }

    };
    await axios
        .get("/api/DbSurvey/SaveSurveyStatus", config)
        .then(response => {
            const storeSurvey = store?.surveyListDisplay?.find(survey => survey.SurveyID == surveyId);
            const historicalSurvey = store?.surveysHistorical?.find(survey => survey.SurveyID == surveyId);

            if (typeof storeSurvey !== "undefined" && storeSurvey !== null) {
                storeSurvey.SurveyStatusID = statusTypeId;
            }
            if (typeof historicalSurvey !== "undefined" && historicalSurvey !== null) {
                historicalSurvey.SurveyStatusID = statusTypeId;
            }

            //if Done, then lock the survey
            if (statusTypeId == 1) {
                updateSurveyInfoCtrl(surveyId, "IsLocked", 1);
            } else {
                updateSurveyInfoCtrl(surveyId, "IsLocked", 0);

            }

            //update the current survey status
            if (store.currentSurvey.SurveyID == surveyId) {
                store.currentSurvey.SurveyStatusID = statusTypeId;
            }

        })
        .catch(error => {
            console.log(error);
        });
}

/**
 * Requests Participant data for results page
 * */
export async function getParticipantResult() {
    const surveyID = store.currentSurvey.SurveyID;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }, params: {
            surveyId: surveyID,
        }

    };
    await axios
        .get("/api/DbSurvey/GetParticipantResult", config)
        .then(response => {
            store.participantResult = response.data
        })
        .catch(error => {
            console.log(error);
        });
}


/**
 * Requests Universe data for results page
 * */
export async function getUniverseResult() {
    const surveyID = store.currentSurvey.SurveyID;
    const countryID = store.currentSurvey.CountryID;
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + getCookie("access_token")
        }, params: {
            surveyId: surveyID,
            country: countryID
        }

    };
    await axios
        .get("/api/DbSurvey/GetUniverseResult", config)
        .then(response => {
            let data = JSON.parse(response.data)
            store.universeResult = {
                "polRetmonthly": data[2].toFixed(1), "returnOnPlanAssets": data[1].toFixed(1)
            }
        })
        .catch(error => {
            console.log(error);
        });
}
